import { Button, Typography } from '@mui/material'
import AddIcon from '@mui/icons-material/Add';

function ButtonAdd({
    onClick,
    title
}) {
  return (
    <Button 
        sx={{ 
            fontSize: '0.8125rem',
            fontWeight:'700',
            background: '#FFF',
            color: '#FC581F',
            textTransform:'none',
            minWidth: {xs: 0,lg: '64px'},
            p:{xs:' 0.688rem 0.688rem', lg:'6px 16px'},
            borderRadius:'62.5rem',
            boxShadow: '1px 1px 4px 0px rgba(0, 0, 0, 0.10), 0px 0px 1px 0px rgba(0, 0, 0, 0.10)',
            '& .MuiButton-startIcon':{
            marginRight: {xs:'0', lg: '8px'},
            marginLeft: {xs:'0', lg: '0px'},
            },
            '&:hover': { 
            backgroundColor: '#FAFAFA'
            }
        }}
        variant="contained" 
        startIcon={<AddIcon sx={{fontSize:'1.5rem !important'}} />}
        onClick={onClick}
    >
        <Typography sx={{ display:{xs:'none', lg:'block'}, fontSize: '0.8125rem', fontWeight:'700', }}>
            {title}
        </Typography>
    </Button>
  )
}

export default ButtonAdd